import { render } from "./UserUpdatePhoto.vue?vue&type=template&id=312020c6"
import script from "./UserUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./UserUpdatePhoto.vue?vue&type=script&lang=js"

import "../../../src/assets/css/avatar.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__